// extracted by mini-css-extract-plugin
export default {"container":"navbar_container__MPQ8B","box":"navbar_box__+yZ7F"};